/**
 * EditProfile.Interact event properties
 *
 * Ref:
 * All Inclusive (Phase 2) Product Spec: https://gotinder.atlassian.net/wiki/x/qEDdAQ
 * All Inclusive Phase 3: https://gotinder.atlassian.net/wiki/x/AoB8CQ
 * Descriptors V1: https://gotinder.atlassian.net/wiki/x/xT7ZAQ
 * Descriptors V2: https://gotinder.atlassian.net/wiki/x/yLLaAQ
 * Project Alibi: https://gotinder.atlassian.net/wiki/x/hk-WAQ
 * Prompts V2: https://gotinder.atlassian.net/wiki/x/WV3bAQ
 * Relationship Intent: https://gotinder.atlassian.net/wiki/x/WgDbAQ
 * Sexual Orientation on Profile: https://gotinder.atlassian.net/wiki/x/aEDWAQ
 * View My Card on Android: https://gotinder.atlassian.net/wiki/x/NpDaAQ
 */

import { Values } from 'Lib/typeUtils';

export const EDIT_PROFILE_INTERACT = 'EditProfile.Interact';

export const Action = {
  DISMISS_BACKGROUND: 'dismiss_background',
  DISMISS_DONE: 'dismiss_done',
  DISMISS_SLIDE: 'dismiss_slide',
  EDIT: 'edit',
  OPEN: 'open',
  SAVE: 'save',
  TAPPY: 'tappy',
  TOGGLE: 'toggle',
  VIEW: 'view',
  VIEW_AUTO_ADVANCE: 'view_auto_advance',
  VIEW_INFO_BOX: 'view_info_box',
  VIEW_SKIP: 'view_skip',
} as const;

export const AppSource = {
  DEEPLINK: 'deeplink',
  DEEPLINK_ATTRACT: 'deeplink_attract',
  DEEPLINK_SHOWCASE: 'deeplink_showcase',
  DEEPLINK_START: 'deeplink_start',
  EDIT_PROFILE: 'editprofile',
  EDIT_PROFILE_GENDER: 'editprofile_gender',
  EDIT_PROFILE_ORIENTATION: 'editprofile_orientation',
  EDIT_TAB: 'edit_tab',
  HOME_AVATAR: 'home_avatar',
  HOME_EDIT_BUTTON: 'home_edit_button',
  HOME_PROFILE_METER_BANNER: 'home_profile_meter_banner',
  I_BUTTON: 'i button',
  PREVIEW_TAB: 'preview_tab',
  PROFILE_DETAIL: 'profiledetail',
  PROMPT: 'prompt',
  RECS: 'recs',
} as const;

export const Property = {
  INTERESTS: 'interests',
  MEDIA_INDEX: 'media_index',
  PREFERENCE: 'preference',
  PROFILE: 'profile',
  SETTING: 'setting',
  TINDER_CARES: 'Tinder Cares',
  VALUE: 'value',
} as const;

export const Subtype = {
  ALL_IN: 'all_in',
  ALL_IN_CUSTOM_GENDER: 'all_in_custom_gender',
  ALL_IN_CUSTOM_ORIENTATION: 'all_in_custom_orientation',
  DISPLAY_ON_PROFILE: 'display_on_profile',
  EDIT: 'edit',
  IDENTITY: 'identity',
  IDENTITY_ALL_IN: 'identity_all_in',
  IDENTITY_LEGACY: 'identity_legacy',
  LEGACY: 'legacy',
  PREVIEW: 'preview',
  PROMPT_ID: 'prompt_id',
  PROMPT_LIST: 'prompt_list',
  SHOW_IN_SELECTION: 'show in selection',
  VISIBILITY: 'visibility',
} as const;

export const Type = {
  EDIT_PROFILE: 'editprofile',
  DESCRIPTOR: 'descriptor',
  GENDER: 'gender',
  INTENT: 'intent',
  INTERESTS: 'interests',
  ORIENTATION: 'orientation',
  USER_PROMPTS: 'user_prompts',
} as const;

export type ActionType = Values<typeof Action>;
export type AppSourceType = Values<typeof AppSource> | null;
export type AttributesType = Record<string, boolean | string[]>;
export type PromptIdType = `pro_${number}`;
export type PropertyType = Values<typeof Property>;
export type SubtypeType = Values<typeof Subtype> | PromptIdType;
// Note: TypeType is confused, renaming it to EventType
export type EventType = Values<typeof Type>;
// TODO: Audit the value (might just be string)
export type ValueType = boolean | number | string | string[] | null;

export type EventData = Partial<{
  action: ActionType;
  appSource: AppSourceType;
  attributes: AttributesType;
  now: ValueType;
  prev: ValueType;
  property: PropertyType;
  subtype: SubtypeType;
  type: EventType;
}>;
